import * as React from "react";
import { CurrencyCode } from "../../../../../../../../Wrap/Constants/Enums/Domain/CurrencyCode";
import { SubAccountType } from "../../../../../../../../Wrap/Constants/Enums/Domain/SubAccountType";
import { QuoteModel } from "../../../../../../../../Wrap/Models/Models/Processes/Quote/QuoteModel";
import {
    getISTPaymentAmount,
    pensionInstrumentSelectionToInstrumentSelection,
} from "../../../../../../../Shared/IST/Components/Shared/Utils";
import { InvestmentSelectionTool as IST } from "../../../../../../../Shared/IST/InvestmentSelectionTool";
import { ProcessType } from "../../../../../../../Shared/IST/Resource/Content";
import { IProcessComponentProps, ProcessComponent } from "../../../../../../../Shared/Process/Process/ProcessComponent";
import { SubAccountTypeHelper } from "../../../../Common/Helpers/SubAccountTypeHelper";
import { AdviserContextStoreStatic } from "../../../../NewBusinessWizard/Stores/Variable";

interface InvestmentSelectionToolProps extends IProcessComponentProps {
    data: QuoteModel;
}

interface InvestmentSelectionToolState {}

export class InvestmentSelectionTool extends ProcessComponent<
    InvestmentSelectionToolProps,
    InvestmentSelectionToolState
> {
    constructor(props: any) {
        super(props);
        this.state = {};
    }

    public render(): JSX.Element {
        const { onChange, data } = this.props;
        const paymentAmount = getISTPaymentAmount(data?.GiaQuote, "GiaTransfers");
        const modelData = JSON.parse(JSON.stringify(data?.GiaQuote));
        modelData.CashInstrument = data.CashInstrument;
        modelData.OwnerHierarchyId = data.OwnerHierarchyId;

        const hasSipp = data.SelectedProducts.some((ele) =>
            SubAccountTypeHelper.isOnPlatformPension(ele.SubAccountType)
        );
        const hasIsa = data.SelectedProducts.some((ele) => ele.SubAccountType == SubAccountType.StocksIsa);
        const clAccountId = new URLSearchParams(window.location.search).get("clAccountId");
        const adviser = AdviserContextStoreStatic.getData();

        return (
            <div>
                <h2 className="mb-20">Investment selection</h2>
                <IST
                    withReRegistrationTransferIn={false}
                    data={data?.GiaQuote?.InstrumentSelections}
                    modelData={modelData}
                    onRef={(ref) => this.appendChild(ref)}
                    onChange={(changes) =>
                        this.onDataChange(
                            (changes) => this.onDataChange(onChange, changes, data, "GiaQuote"),
                            changes,
                            data.GiaQuote,
                            "InstrumentSelections"
                        )
                    }
                    from={hasSipp ? SubAccountType.Sipp : hasIsa ? SubAccountType.StocksIsa : null}
                    fromData={
                        hasSipp
                            ? pensionInstrumentSelectionToInstrumentSelection(
                                  data.PensionQuote?.PreRetirementInstrumentSelections,
                                  data.PensionQuote?.PostRetirementInstrumentSelections,
                                  data.CashInstrument
                              )
                            : hasIsa
                            ? this.props.data.ISAQuote?.InstrumentSelections
                            : null
                    }
                    showErrorMsgPopUp={(msg) => this.props.showErrorMsgPopUp(msg)}
                    type={ProcessType.Quote}
                    hiercharyId={data?.GiaQuote?.HierarchyId}
                    headAccountHierarchyId={data.ExistingAccountHierarchyId}
                    companyCode={adviser.Company}
                    claccountId={clAccountId}
                    product={SubAccountType.InvestmentAccount}
                    paymentAmount={{ Amount: paymentAmount, Currency: CurrencyCode.GBP }}
                    bankAccounts={["Client Bank Account"]}
                    onBankChange={(bankInfo) => {}}
                    onDistributionDividendOptions={(changes) => {
                        this.onDataChange(
                            (changes) => this.onDataChange(onChange, changes, data, "GiaQuote"),
                            changes,
                            data.GiaQuote,
                            "DistributionDividendOptions"
                        );
                    }}
                    decisionMakerHierarchyId={data?.GiaQuote?.HierarchyId}
                    accountAdviceType={data?.AccountAdviceType}
                    accountServiceProposition={data?.AccountServiceProposition}
                    onDecisionMakerChange={(v) => this.onDataChange(onChange, v, data, "GiaQuote")}
                    treasuredAssetsProductIds={[68057715]}
                    onChangeTreasuredAssets={() => {}}
                />
            </div>
        );
    }
}
